// pages/Vehicles.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "../components/DataTable";
import API from "../config/config";

const Vehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await axios.get(API.ADMIN.VEHICLE_LIST);
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVehicles();
  }, []);

  const handleDelete = async (vehicleId) => {
    try {
      await axios.delete(`${API.ADMIN.VEHICLE_DELETE}/${vehicleId}`);
      setVehicles(vehicles.filter((vehicle) => vehicle._id !== vehicleId));
    } catch (error) {
      console.error("Error deleting vehicle:", error);
    }
  };

  const columns = [
    { Header: "Type", accessor: "vehicleType" },
    { Header: "Sub-Type", accessor: "subType" },
    {
      Header: "Status",
      accessor: "isAvailable",
      Cell: ({ value }) => (value ? "Available" : "Unavailable"),
    },
  ];

  return (
    <DataTable
      data={vehicles}
      columns={columns}
      loading={loading}
      addLink="/vehicles/add"
      editPath="/vehicles/edit"
      detailPath="/vehicles/detail"
      deleteHandler={handleDelete}
    />
  );
};

export default Vehicles;
